import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "checkered-flag-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M13.1364 3.67483L11.4415 2.97511C8.96439 1.9109 6.03795 1.98491 3.6179 3.41863C3.3729 3.56378 3.24069 3.82658 3.25058 4.09245C3.24826 4.11647 3.24707 4.14083 3.24707 4.16546V21.0039C3.24707 21.4181 3.58286 21.7539 3.99707 21.7539C4.41128 21.7539 4.74707 21.4181 4.74707 21.0039V16.4404C6.65308 15.4689 8.95623 15.464 10.9272 16.3205L12.5208 17.059L12.5364 17.0661C15.0437 18.159 17.9627 18.0667 20.3825 16.6332C20.6104 16.4981 20.7502 16.2529 20.7502 15.9879V4.02698C20.7502 3.75752 20.6056 3.50878 20.3715 3.37536C20.1374 3.24195 19.8497 3.24437 19.6179 3.38172C17.647 4.54938 15.2532 4.59739 13.1499 3.68056L13.1364 3.67483ZM4.74707 14.7951C6.93233 13.9227 9.41022 14.023 11.5342 14.9488L11.5499 14.9559L13.1435 15.6944C15.1064 16.5474 17.3469 16.5215 19.2502 15.5456V5.22985C17.0857 6.09458 14.6747 5.97951 12.5574 5.05859L10.8537 4.35525C8.90745 3.51763 6.65306 3.5318 4.74707 4.50803V14.7951Z"
    }, null, -1)
  ])))
}
export default { render: render }